/* eslint-disable radix */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { Button, Spinner } from 'reactstrap';
import { Col, FlexboxGrid, Form, FormGroup } from 'rsuite';
import SelectInput from '~/components/selectInput/SelectInput';
import Lista from './Lista';
import { Container } from './styles';

function Card({
  modulos,
  loading,
  isSelected,
  setIsSelected,
  setLoading,
  companyData,
  form,
  setForm,
}) {
  function handleFormChange(value) {
    setForm({ ...form, ...value });
  }
  return (
    <Container>
      <h1>Grupos módulo</h1>
      <Form
        style={{ width: '100%' }}
        formValue={form}
        onChange={handleFormChange}
        onSubmit={() => {
          setIsSelected(true);
        }}
        fluid
        className="pageForm"
      >
        {loading ? (
          <div />
        ) : (
          <FormGroup className="pageFormContainer" style={{ display: 'block' }}>
            <FlexboxGrid className="marginTop" style={{ marginTop: '16px' }}>
              <FlexboxGrid.Item componentClass={Col} colspan={24} md={12}>
                <SelectInput
                  margin="0"
                  width="100%"
                  label="Selecione a empresa"
                  form={form}
                  valueKey="idPessoaEmpresa"
                  labelKey="razaoSocialNome"
                  setForm={setForm}
                  value={form.idPessoaEmpresa}
                  options={companyData}
                  placeholder="Escolha uma opção"
                  state="idPessoaEmpresa"
                  onChange={() => {
                    setIsSelected(false);
                  }}
                />
              </FlexboxGrid.Item>
              <FlexboxGrid.Item componentClass={Col} colspan={24} md={12}>
                <SelectInput
                  margin="0"
                  width="100%"
                  label="Selecione o módulo"
                  form={form}
                  valueKey="id"
                  labelKey="nome"
                  setForm={setForm}
                  value={form.idModulo}
                  options={modulos}
                  placeholder="Escolha uma opção"
                  state="idModulo"
                  onChange={() => {
                    setIsSelected(false);
                  }}
                />
              </FlexboxGrid.Item>
            </FlexboxGrid>
          </FormGroup>
        )}
        {loading ? (
          <Button color="primary" disabled size="sm">
            <Spinner size="sm" color="light" />
          </Button>
        ) : (
          <Button
            color="primary"
            onClick={() => {
              setIsSelected(true);
            }}
            size="sm"
            disabled={!form.idModulo}
          >
            <FaSearch /> Buscar
          </Button>
        )}
        {isSelected ? <Lista setLoading={setLoading} loading={loading} /> : ''}
      </Form>
    </Container>
  );
}

export default Card;
